import {h, render, Component} from 'preact';
import {Link} from 'react-router-dom';
import linkState from 'linkstate';
import Cookies from 'universal-cookie';
import q from 'q';
import { OnboardingService, CheckboxWithLabel } from "@webapp/preact-shared";

import UserAuth from '../../services/userAuth';
import Util from '../../services/util';
import authContainer from '../tags/auth-container';
import DesktopDataProvider from '../../services/desktopDataProvider';
import NavigationService from '../../services/navigation';
import FeatureSettingsService from '../../services/featureSettingsService';
import { SessionStorageKeys } from '../../services/sessionStorageKeys.const';
import { featureFlags } from '../../services/featureFlags.const';

export class Login extends Component {
	constructor() {
		super();
		this.cookies = new Cookies();
		this.desktopDataProvider = new DesktopDataProvider();
		this.state = {
			isFeatureFlagsLoading: true,
			isWebAppSignInPageV2Enabled: false,
			signInIdPStep: 'username',
			idpRedirectUrl: null,
			preloadedCompanyLogo: '',
			isMobile: Util.isMobile(),
			isTablet: Util.isTablet(),
			username: '',
			password: '',
			isRememberMe: false,
			loginError: '',
			signInButtonContent: 'Sign in',
			signInButtonLoading: false,
			deviceInfo: null
		};
		this.q = q;
	}

	componentDidMount() {
		//ymakhov. We must reset settings cache for correct displaying of login page (for Workplace or 3rd party identity provider)
		FeatureSettingsService.init(true).then(() => {
			this.setState({
				isFeatureFlagsLoading: false,
				isWebAppSignInPageV2Enabled: FeatureSettingsService.isFeatureEnabled('isWebAppSignInPageV2Enabled')
			})
			if (this.state.isWebAppSignInPageV2Enabled) {
				this.setState({
					signInIdPStep: 'username',
					signInButtonContent: 'Next'
				})
			}

			//remove device compliance cached results
			sessionStorage.removeItem(SessionStorageKeys.deviceComplianceInfoResult);
			sessionStorage.removeItem(SessionStorageKeys.deviceComplianceChecksInfo);
			document.title = 'Login | workplace_';
			if (this.cookies.get('authenticationMode') !== 'simple') {
			this.cookies.remove('userId', {path: '/'});
			this.cookies.remove('authenticationMode', {path: '/'});
			}

			this.cookies.remove('lastLoginUsername', {path: '/'});
			this.cookies.remove('w-device-compliance-check-info', {path: '/'});

			this.deviceInfoPooling().then(results => {
				this.setState({deviceInfo: results[1]});
			});

			if (this.props.history.location.state && this.props.history.location.state.from.indexOf('verification') > -1) {
				this.setState({loginError: 'Login request denied'});
				this.props.history.location.state = null;
			} else if (sessionStorage.getItem(SessionStorageKeys.sessionLifespanLimit)) {
				this.setState({loginError: 'You were signed out to stay compliant with your security policy.'});
				sessionStorage.removeItem(SessionStorageKeys.sessionLifespanLimit)
			} else if (sessionStorage.getItem(SessionStorageKeys.sessionTimeoutLimit)) {
				this.setState({loginError: `You have been signed out after ${sessionStorage.getItem(SessionStorageKeys.sessionTimeoutLimit)} mins of inactivity`});
				sessionStorage.removeItem(SessionStorageKeys.sessionTimeoutLimit)
			} else {
				this.setState({loginError: ''});
			}

			const rememberMeInfo = this.cookies.get('rememberMeInfo');
			if (typeof rememberMeInfo !== 'undefined') {
				this.setState({username: rememberMeInfo, isRememberMe: true});
				this.props.focusById('user_password');
			} else {
				const back = Util.getUrlParameter('back');
				if (back && back.length) {
					const backusername = Util.getUrlParameterByName('username', back, true);
					if (backusername && backusername.length) {
						this.setState({username: backusername});
						this.props.focusById('user_password');
					} else {
						this.props.focusById('user_name');
					}
				} else {
					this.props.focusById('user_name');
				}
			}
			const onboardingUsername = sessionStorage.getItem(SessionStorageKeys.onboardingUsername)
			if (onboardingUsername) {
				this.setState({username: onboardingUsername, isRememberMe: false});
				this.cookies.remove('rememberMeInfo');
			}
		});
	}

	deviceInfoPooling = () => {
		return this.retryOnFailed(() => {
			return this.desktopDataProvider.getDeviceInfo({async: true, timeout: 3000}, this.state.deviceInfo);
		})
			.catch(reason => {
				console.log('Desktop communication failed: ' + reason.exception);
			});
	};

	retryOnFailed = func => {
		let attempts = 10;
		let deviceInfoPromise = func();
		while (attempts--) {
			deviceInfoPromise = deviceInfoPromise.catch(() => {
				const deferred = this.q.defer();
				setTimeout(() => {
						return func().catch(deferred.reject);
					}, 2000);
				return deferred.promise;
			});
		}
		return deviceInfoPromise;
	};

	login = () => {
		if (this.state.signInButtonLoading) {
		} else {
			this.setState({ username: this.state.username.trim() });
			const {username, password} = this.state;
			if (!password && !username) {
				this.setState({loginError: 'Please enter your username and password.'});
				return false;
			} else if (!password) {
				this.setState({loginError: 'Please enter your password.'});
				return false;
			} else if (!username) {
				this.setState({loginError: 'Please enter your username.'});
				return false;
			} else {
				this.setState({loginError: '', signInButtonContent: 'Please wait', signInButtonLoading: true});
			}

			if (!window.navigator.onLine) {
				this.setState({
					loginError: 'Internet connection is not available.',
					signInButtonLoading: false,
					signInButtonContent: 'Sign in'
				});
				return false;
			}

			const authData = {
				userName: username,
				password: password
			};

			UserAuth.login('/api/auth/v2/login', authData, this.state.deviceInfo).then(response => {
				const data = response.data;
				const status = response.status;

				if (data.type === 'federated') {
					this.props.callback(data);
					return;
				}

				this.setRememberMeCookieIfNeeded(username);
				this.setLastLoginUsernameCookie(username);

				this.cookies.set('userId', data.userId, {path: '/'});
				this.cookies.set('autoLoginEnabled', data.autoLoginEnabled ? 'enabled' : 'disabled', {path: '/'});

				if (status !== 200 && status !== 202) {
					this.props.mfaRedirection(data);
					return;
				}

				FeatureSettingsService.init(true).then(() => {
					UserAuth.getCompanySettings().then((response) => {
						const settings = response.data;
						data.passwordExpiresIn = settings.passwordExpiresIn;
						data.passwordIsActivationCode = settings.passwordIsActivationCode;
						const isOnboardingV3Enabled = settings.isStrongholdV2FamilyCompany;
						const isFrictionlessOnboardingEnabled = FeatureSettingsService.isFeatureEnabled(featureFlags.FrictionlessOnboardingEnabled);
						sessionStorage.setItem(SessionStorageKeys.onboardingV3Enabled, isOnboardingV3Enabled ? 'enabled' : 'disabled');

						OnboardingService.getOnboardingStatus().then(response => {
							const onboardingStatus = response.data.onboardingStatus;
							sessionStorage.setItem(SessionStorageKeys.onboardingStatus, onboardingStatus);

							if (status === 202) {
								this.props.mfaRedirection(data);
								return;
							}

							//TODO: ymakhov. Need to understand why we have this condition
							//Probably, it's related to Frontline logic...
							if (settings.passwordExpiresIn === null) {
								sessionStorage.removeItem(SessionStorageKeys.onboardingStatus);
								this.props.loginForSimpleAuth(data);
								return false;
							}

							// if frictionless onboarding enabled we do not need the redirection flow from onboarding V1 and V2
							if (isFrictionlessOnboardingEnabled){
								sessionStorage.removeItem(SessionStorageKeys.onboardingStatus);
								this.props.loginForSimpleAuth(data);
								return false;
							}

							const isOnboardingV1OrV2 = !isOnboardingV3Enabled && this.isOnboardingV1OrV2InProgress(onboardingStatus);
							if (isOnboardingV1OrV2) {
								//onboarding v2 logic -->
								if (onboardingStatus === 'None' || onboardingStatus === 'Required' || onboardingStatus === 'InProgress') {
									this.cookies.remove('authenticationMode', {path: '/'});
									if (FeatureSettingsService.isFeatureEnabled('isOnboardingV2Enabled')) {
										if (this.state.isMobile || this.state.isTablet) {
											this.props.goToPage('/mobile-onboarding-not-supported');
											return false;
										}

										OnboardingService.getUserSettings().then(response => {
											const userSettings = {...response.data};
											sessionStorage.setItem(SessionStorageKeys.userSettings, JSON.stringify(userSettings));
											this.setState({preloadedCompanyLogo: userSettings.companyLogoUrl});
											OnboardingService.preloadCompanyLogo(userSettings.companyLogoUrl).then(() => {
												NavigationService.goToWebappUrl('/', 'onboarding');
											}, () => {
												NavigationService.goToWebappUrl('/', 'onboarding');
											});
										}, () => {
											this.setState({loginError: 'Server error. Please try later.'});
										});
									} else {
										//onboarding v1 logic -->
										if(settings.passwordExpiresIn <= 0 && (onboardingStatus === 'Required' || onboardingStatus === 'InProgress') && (this.state.isMobile || this.state.isTablet)) {
											this.props.goToPage('/mobile-onboarding-not-supported');
											return false;
										} else {
											data.passwordIsActivationCode = null;
											//redirect to /online and after that to onboarding V1
											this.props.loginForSimpleAuth(data);
										}
										//<-- onboarding v1 logic
									}
								} else if (onboardingStatus === 'DeviceSignIn') {
									this.cookies.remove('authenticationMode', {path: '/'});
									if (this.state.isMobile || this.state.isTablet) {
										this.props.goToPage('/mobile-onboarding-not-supported');
									} else {
										this.props.goToPage('/installer-error');
									}
								}

								return false;
								//<-- onboarding v2 logic
							}

							if (!isOnboardingV3Enabled) {
								this.props.requireNativeAppInstall(data);
								return false;
							}

							//onboarding v3 logic -->
							this.props.processOnboardingV3Redirection(() => {
								this.props.requireNativeAppInstall(data);
							});
							//<-- onboarding v3 logic
						}, () => {
							this.setState({signInButtonLoading: false, signInButtonContent: 'Sign in'});
							this.setState({loginError: 'Server error. Please try later.'});
						})
					}, () => {
						this.setState({signInButtonLoading: false, signInButtonContent: 'Sign in'});
						this.setState({loginError: 'Server error. Please try later.'});
					});
				});

			}, error => {
				this.setState({signInButtonLoading: false, signInButtonContent: 'Sign in'});
				/* istanbul ignore else */
				if (window.navigator.onLine) {
					const errorData = error.response.data;
					const errorStatus = error.response.status;
					if (errorStatus === 401 || errorStatus === 403) {
						this.setState({loginError: 'Username/Password combination was wrong. Please try again.'});
						if (errorData === 'User phone is not registered') {
							this.setState({loginError: 'Mobile phone not registered.'});
						}
					} else {
						this.setState({loginError: 'Server error. Please try later.'});
					}
				} else {
					this.setState({loginError: 'Internet connection is not available.'});
				}
			});
		}
	};

	isOnboardingV1OrV2InProgress = (onboardingStatus) => {
		return onboardingStatus === 'None'
			|| onboardingStatus === 'Required'
			|| onboardingStatus === 'InProgress'
			|| onboardingStatus === 'DeviceSignIn';
	}

	submitForm = e => {
		e.preventDefault();
		if (this.state.isWebAppSignInPageV2Enabled) {
			this.idpLogin();
		} else {
			this.login();
		}
	};

	checkRememberMe = () => {
		this.setState({isRememberMe: !this.state.isRememberMe})
	};

	saveUsername = () => {
		sessionStorage.setItem(SessionStorageKeys.authUsername, this.state.username);
	};

	onIdPUsernameInput = (e) => {
		if (this.state.username === e.target.value){
			return;
		}

		const username = e.target.value;
		this.setState({
			username,
			loginError: '',
			signInIdPStep: 'username',
			signInButtonContent: 'Next',
			idpRedirectUrl: null
		});
	}

	onIdPPasswordInput = (e) => {
		const password = e.target.value;
		this.setState({
			password,
			loginError: ''
		});
	}

	idpLogin = () => {
		if (this.state.signInButtonLoading) {
		} else {
			this.setState({ username: this.state.username.trim() });
			const username = this.state.username;
			if (this.state.isWebAppSignInPageV2Enabled) {
				switch (this.state.signInIdPStep) {
					case 'username':
						if (username) {
							this.setState({
								signInButtonLoading: true
							});
							UserAuth.getIdPData(username).then(({data}) => {
								if (data.redirectUrl) {
									this.setRememberMeCookieIfNeeded(username);
									this.setLastLoginUsernameCookie(username);
									this.setState({
										signInButtonLoading: false,
										loginError:  data.identityProvider.toLowerCase() !== 'workplace'?
										'Your company has Single Sign On enabled. Click “Continue” to sign in to your account.':
										"Click “Continue” to complete onboarding.",
										signInIdPStep: 'idpRedirect',
										signInButtonContent: 'Continue',
										idpRedirectUrl: data.redirectUrl
									});
								} else {
									this.setState({
										signInButtonLoading: false,
										loginError: '',
										signInIdPStep: 'password',
										signInButtonContent: 'Sign in'
									});
								}
							}, () => {
								this.setState({
									signInButtonLoading: false,
									loginError: '',
									signInIdPStep: 'password',
									signInButtonContent: 'Sign in'
								});
							})
						} else {
							this.setState({loginError: 'Please enter your username.', username: ''});
						}
						break;
					case 'password':
						this.login();
						break;
					case 'idpRedirect':
						if (username) {
							window.location.href = this.state.idpRedirectUrl;
						} else {
							this.setState({signInIdPStep: 'username', loginError: 'Please enter your username.'});
						}
						break;
				}
			}
		}
	};

	setRememberMeCookieIfNeeded = (username) => {
		if (this.state.isRememberMe) {
			this.cookies.remove('rememberMeInfo');
			let expireDate = new Date();
			expireDate.setDate(expireDate.getDate() + 100);
			this.cookies.set('rememberMeInfo', username, {'expires': expireDate});
		} else {
			this.cookies.remove('rememberMeInfo');
		}
	}

	setLastLoginUsernameCookie = (username) => {
		this.cookies.set('lastLoginUsername',username, {path: '/'});
	}

	renderIdpSignInPage = () => {
		return (
			<div>
				<img src={this.props.loginPageHeaderUrl || 'img/blank-header-image.gif'} className='login-header-image'
					 alt='login-bg'/>
				<div className='form'>
					<form role='form' onSubmit={this.submitForm}>
						<div className='input-fields'>
							<div className='form-group'>
								<input
									id='user_name'
									className='form-control'
									required
									type='text'
									placeholder='Username'
									value={this.state.username}
									onInput={this.onIdPUsernameInput}
								/>
							</div>
							{this.state.signInIdPStep === 'password' ? (
								<div className='form-group'>
									<input
										id='user_password'
										ref={function(input) {
											setTimeout(()=>{
												if (input != null) {
												  input.focus();
												}
											},0)
										  }}
										className='form-control'
										required
										type='password'
										placeholder='Password'
										value={this.state.password}
										onInput={this.onIdPPasswordInput}
									/>
								</div>
							) : null}
							{this.state.loginError ? <p className='idp-login-error'>{this.state.loginError}</p> : null}
						</div>
						<div className='form-submit-section'>
							<a tabIndex='0'
							id='login-btn'
							className={`button button-prime signInBtn ${this.state.signInButtonLoading ? 'loading' : ''}`}
							onClick={this.idpLogin}
							>{this.state.signInButtonContent}</a>
							<div className='remember-me'>
								{this.state.signInIdPStep === 'idpRedirect' ? null : (
									<CheckboxWithLabel label='Remember username' checked={this.state.isRememberMe} action={this.checkRememberMe}/>
								)}
							</div>
							<div className='form-submit d-flex justify-content-between align-items-center'>
								{this.props.renderHelpLink('', true)}
								{this.state.signInIdPStep === 'password' ? (
									<Link class='forgot-password' to='/forget-password' onClick={this.saveUsername}>
										Forgot password?
									</Link>
								) : null}
							</div>
						</div>
						<input type='submit' className='hidden-submit-input'/>
					</form>
				</div>
			</div>
		)
	};

	render({companyProviderName, loginPageHeaderUrl, renderHelpLink}, {isFeatureFlagsLoading, isWebAppSignInPageV2Enabled, signInIdPStep, preloadedCompanyLogo, isMobile, username, password, isRememberMe, loginError, signInButtonContent, signInButtonLoading}) {
		return (
			isFeatureFlagsLoading ? null : (
				<div>
					<img src={preloadedCompanyLogo} alt='company-logo' className='pre-loaded-company-logo'/>
					{isMobile ? (
						<x-mobile>
							{isWebAppSignInPageV2Enabled ? (
								<section className='mobile-login login-idp'>
									{this.renderIdpSignInPage()}
								</section>
							) : (
								<section className='mobile-login'>
									<img src={loginPageHeaderUrl || 'img/blank-header-image.gif'} className='login-header-image'
										 alt='login-bg'/>
									<div className='form'>
										{loginError ? <p className='login-error'>{loginError}</p> :
											<p className='login-error'>&nbsp;</p>}
										<form role='form' onSubmit={this.submitForm}>
											<div className='form-group clearfix'>
												<input
													id='user_name'
													className='form-control'
													required
													type='text'
													placeholder='Your username'
													value={username}
													onInput={linkState(this, 'username')}
												/>
											</div>
											<div className='form-group clearfix'>
												<input
													id='user_password'
													className='form-control'
													required
													type='password'
													placeholder='Your password'
													value={password}
													onInput={linkState(this, 'password')}
												/>
											</div>
											<div className='d-flex justify-content-between align-items-center'>
												<div className='form-group remember-me'>
													<CheckboxWithLabel label='Remember username' checked={isRememberMe}
																	   action={this.checkRememberMe}/>
												</div>
												<div className='form-submit'>
													<a tabIndex='0'
													   id='login-btn'
													   className={`button button-prime flex-shrink-0 signInBtn ${signInButtonLoading ? 'loading' : ''}`}
													   onClick={this.login}
													>{signInButtonContent}</a>
												</div>
											</div>
											<input type='submit' className='hidden-submit-input'/>
										</form>
										<div className='help-link' tabIndex='-1'>
											{renderHelpLink('', true)}
										</div>
									</div>
								</section>
							)}
						</x-mobile>
					) : (
						<x-desktop>
							{isWebAppSignInPageV2Enabled ? (
								<section className='auth-modal-container login login-idp'>
									{this.renderIdpSignInPage()}
								</section>
							) : (
								<section className='auth-modal-container login'>
									<img src={loginPageHeaderUrl || 'img/blank-header-image.gif'} className='login-header-image'
										 alt='login-bg'/>
									<div className='form'>
										<form role='form' onSubmit={this.submitForm}>
											<div className='form-group clearfix'>
												<label htmlFor='user_name'>Username:</label>
												<input
													id='user_name'
													className='form-control'
													required
													type='text'
													placeholder=''
													value={username}
													onInput={linkState(this, 'username')}
												/>
											</div>
											<div className='form-group clearfix'>
												<label htmlFor='user_password'>Password:</label>
												<input
													id='user_password'
													className='form-control'
													required
													type='password'
													placeholder=''
													value={password}
													onInput={linkState(this, 'password')}
												/>
											</div>
											<div className='form-group remember-me'>
												<CheckboxWithLabel label='Remember username' checked={isRememberMe}
																   action={this.checkRememberMe}/>
												<Link class='forgot-password' to='/forget-password' onClick={this.saveUsername}>
													Forgot password?
												</Link>
											</div>
											{loginError ? <p className='login-error'>{loginError}</p> :
												<p className='login-error'>&nbsp;</p>}
											<div className='form-submit d-flex justify-content-between align-items-center'>
												<div tabIndex='-1'>
													{renderHelpLink('', true)}
												</div>
												<a tabIndex='0'
												   id='login-btn'
												   className={`button button-prime flex-shrink-0 signInBtn ${signInButtonLoading ? 'loading' : ''}`}
												   onClick={this.login}
												>{signInButtonContent}</a>
											</div>
											<input type='submit' className='hidden-submit-input'/>
										</form>
									</div>
								</section>
							)}
						</x-desktop>
					)}
				</div>
			)
		);
	}
}

export default authContainer(Login);



// WEBPACK FOOTER //
// ./src/scripts/views/login/login.js